import React from "react";
import { useTranslation } from "react-i18next";

const Button = ({ extraP, path }) => {
  const { t } = useTranslation();
  const handclick = () => {
    window.location.href = path;
  };
  return (
    <button
      onClick={handclick}
      className="main-btn"
      style={{ paddingLeft: extraP, paddingRight: extraP }}
    >
      {t("Book")}
    </button>
  );
};

export default Button;
